import { Item } from './item.model';

export class ItemSelectedEvent {
    selectedItem: Item;
}
